// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.v-list-item--dense[data-v-0e48ea74],\n.v-list--dense .v-list-item[data-v-0e48ea74] {\n  min-height: 52px;\n}\n.theme--dark.v-list-item--active[data-v-0e48ea74]:hover::before,\n.theme--dark.v-list-item--active[data-v-0e48ea74]::before {\n  opacity: 0;\n}\n\n/* height */\n.height-70[data-v-0e48ea74] {\n  height: 70px;\n}\n.primary-lighten[data-v-0e48ea74] {\n  background: rgba(68, 68, 68, 0.5);\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
